var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "max-width": "700",
      "width": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "align-end pa-4",
    attrs: {
      "color": "primary",
      "dark": "",
      "height": "auto"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v("Board Documents")]), _c('v-spacer'), _c('v-select', {
    attrs: {
      "color": "secondary",
      "hide-details": "",
      "items": _vm.years,
      "label": "Year"
    },
    on: {
      "change": _vm.onYearSelect
    },
    model: {
      value: _vm.yearSelected,
      callback: function ($$v) {
        _vm.yearSelected = $$v;
      },
      expression: "yearSelected"
    }
  })], 1), _c('v-card-text', {
    staticStyle: {
      "height": "50vh",
      "overflow-y": "auto"
    }
  }, [_vm.yearSelectedLoading ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Getting " + _vm._s(_vm.yearSelected) + " documents...")])], 1), _c('v-list-item-icon', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "vaule": _vm.yearSelectedLoading
    }
  })], 1)], 1) : _c('v-list', {
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [_vm._l(_vm.documents[_vm.yearSelected], function (docs, month) {
    var _vm$months;

    return [_c('v-subheader', {
      key: month + 'h',
      staticClass: "text-body-1 primary--text font-weight-bold",
      domProps: {
        "textContent": _vm._s(((_vm$months = _vm.months) === null || _vm$months === void 0 ? void 0 : _vm$months[month]) || '')
      }
    }), _c('v-divider', {
      key: ("d1-" + month)
    }), _vm._l(docs, function (doc) {
      return [_c('v-list-item', {
        key: doc.id
      }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(doc.title))])], 1), _c('v-list-item-icon', [_c('v-btn', {
        attrs: {
          "color": "primary",
          "disabled": !(doc !== null && doc !== void 0 && doc.file),
          "href": doc !== null && doc !== void 0 && doc.file ? ("" + (_vm.baseFileUrl) + (doc.file)) : null,
          "icon": "",
          "small": "",
          "target": "_blank"
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v(" mdi-file-download-outline ")])], 1)], 1)], 1), _c('v-divider', {
        key: 'd3' + doc.id
      })];
    })];
  })], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }